module.exports = __webpack_public_path__ + "media/src/assets/Images/CloseTableArrow-e31ea26bbfa28d35af2e13993839728d.svg";